import { render, staticRenderFns } from "./UaMatching.vue?vue&type=template&id=1a2163c0"
import script from "./UaMatching.vue?vue&type=script&lang=js"
export * from "./UaMatching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports